function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.ahoy = t() : e.ahoy = t();
}(window, function () {
  return function (e) {
    var t = {};

    function n(i) {
      if (t[i]) return t[i].exports;
      var r = t[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, i) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: i
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
      var i = Object.create(null);
      if (n.r(i), Object.defineProperty(i, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        n.d(i, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return i;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t) {
    var n = function n(e) {
      return void 0 === e;
    },
        i = function i(e) {
      return Array.isArray(e);
    },
        r = function r(e) {
      return e && "number" == typeof e.size && "string" == typeof e.type && "function" == typeof e.slice;
    },
        o = function o(e, t, a, s) {
      return (t = t || {}).indices = !n(t.indices) && t.indices, t.nullsAsUndefineds = !n(t.nullsAsUndefineds) && t.nullsAsUndefineds, t.booleansAsIntegers = !n(t.booleansAsIntegers) && t.booleansAsIntegers, a = a || new FormData(), n(e) || (null === e ? t.nullsAsUndefineds || a.append(s, "") : function (e) {
        return "boolean" == typeof e;
      }(e) ? t.booleansAsIntegers ? a.append(s, e ? 1 : 0) : a.append(s, e) : i(e) ? e.length && e.forEach(function (e, n) {
        var i = s + "[" + (t.indices ? n : "") + "]";
        o(e, t, a, i);
      }) : function (e) {
        return e instanceof Date;
      }(e) ? a.append(s, e.toISOString()) : !function (e) {
        return e === Object(e);
      }(e) || function (e) {
        return r(e) && "string" == typeof e.name && ("object" == _typeof(e.lastModifiedDate) || "number" == typeof e.lastModified);
      }(e) || r(e) ? a.append(s, e) : Object.keys(e).forEach(function (n) {
        var r = e[n];
        if (i(r)) for (; n.length > 2 && n.lastIndexOf("[]") === n.length - 2;) {
          n = n.substring(0, n.length - 2);
        }
        o(r, t, a, s ? s + "[" + n + "]" : n);
      })), a;
    };

    e.exports = {
      serialize: o
    };
  }, function (e, t, n) {
    "use strict";

    n.r(t);

    var i = n(0),
        r = function r(e, t, n, i) {
      var r = "",
          o = "";

      if (n) {
        var _e = new Date();

        _e.setTime(_e.getTime() + 60 * n * 1e3), r = "; expires=" + _e.toGMTString();
      }

      i && (o = "; domain=" + i), document.cookie = e + "=" + escape(t) + r + o + "; path=/";
    },
        o = function o(e) {
      var t,
          n,
          i = e + "=",
          r = document.cookie.split(";");

      for (t = 0; t < r.length; t++) {
        for (n = r[t]; " " === n.charAt(0);) {
          n = n.substring(1, n.length);
        }

        if (0 === n.indexOf(i)) return unescape(n.substring(i.length, n.length));
      }

      return null;
    };

    var a = {
      urlPrefix: "",
      visitsUrl: "/ahoy/visits",
      eventsUrl: "/ahoy/events",
      page: null,
      platform: "Web",
      useBeacon: !0,
      startOnReady: !0,
      trackVisits: !0,
      cookies: !0,
      cookieDomain: null,
      headers: {},
      visitParams: {},
      withCredentials: !1,
      visitDuration: 240,
      visitorDuration: 1051200
    },
        s = window.ahoy || window.Ahoy || {};
    s.configure = function (e) {
      for (var _t in e) {
        e.hasOwnProperty(_t) && (a[_t] = e[_t]);
      }
    }, s.configure(s);
    var c,
        u,
        l,
        f = window.jQuery || window.Zepto || window.$,
        d = !1,
        p = [],
        h = "undefined" != typeof JSON && void 0 !== JSON.stringify,
        g = [];

    function y() {
      return a.urlPrefix + a.eventsUrl;
    }

    function m() {
      return (a.useBeacon || a.trackNow) && (e = a.headers, 0 === Object.keys(e).length) && h && void 0 !== window.navigator.sendBeacon && !a.withCredentials;
      var e;
    }

    function v(e, t, n) {
      r(e, t, n, a.cookieDomain || a.domain);
    }

    function b(e) {
      return o(e);
    }

    function k(e) {
      r(e, "", -1);
    }

    function x(e) {
      b("ahoy_debug") && window.console.log(e);
    }

    function w() {
      var e;

      for (; e = p.shift();) {
        e();
      }

      d = !0;
    }

    function _(e, t, n) {
      document.addEventListener(e, function (e) {
        (function (e, t) {
          var n = e.matches || e.matchesSelector || e.mozMatchesSelector || e.msMatchesSelector || e.oMatchesSelector || e.webkitMatchesSelector;
          return n ? n.apply(e, [t]) : (x("Unable to match"), !1);
        })(e.target, t) && n(e);
      });
    }

    function O() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
        var t = 16 * Math.random() | 0;
        return ("x" == e ? t : 3 & t | 8).toString(16);
      });
    }

    function S() {
      a.cookies && h && v("ahoy_events", JSON.stringify(g), 1);
    }

    function P() {
      var e = document.querySelector("meta[name=csrf-token]");
      return e && e.content;
    }

    function j(e) {
      var t = P();
      t && e.setRequestHeader("X-CSRF-Token", t);
    }

    function A(e, t, n) {
      if (h) if (f && f.ajax) f.ajax({
        type: "POST",
        url: e,
        data: JSON.stringify(t),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        beforeSend: j,
        success: n,
        headers: a.headers,
        xhrFields: {
          withCredentials: a.withCredentials
        }
      });else {
        var _i = new XMLHttpRequest();

        _i.open("POST", e, !0), _i.withCredentials = a.withCredentials, _i.setRequestHeader("Content-Type", "application/json");

        for (var _e2 in a.headers) {
          a.headers.hasOwnProperty(_e2) && _i.setRequestHeader(_e2, a.headers[_e2]);
        }

        _i.onload = function () {
          200 === _i.status && n();
        }, j(_i), _i.send(JSON.stringify(t));
      }
    }

    function T(e) {
      var t = {
        events: [e]
      };
      return a.cookies && (t.visit_token = e.visit_token, t.visitor_token = e.visitor_token), delete e.visit_token, delete e.visitor_token, t;
    }

    function C(e) {
      s.ready(function () {
        A(y(), T(e), function () {
          for (var _t2 = 0; _t2 < g.length; _t2++) {
            if (g[_t2].id == e.id) {
              g.splice(_t2, 1);
              break;
            }
          }

          S();
        });
      });
    }

    function M(e) {
      s.ready(function () {
        var t = T(e),
            n = function () {
          var e = document.querySelector("meta[name=csrf-param]");
          return e && e.content;
        }(),
            r = P();

        n && r && (t[n] = r), t.events_json = JSON.stringify(t.events), delete t.events;

        try {
          (navigator.sendBeacon && navigator.sendBeacon.bind(navigator))(y(), Object(i.serialize)(t));
        } catch (e) {}
      });
    }

    function V() {
      return a.page || window.location.pathname;
    }

    function I(e) {
      return e && e.length > 0 ? e : null;
    }

    function N(e) {
      for (; e && e !== document; e = e.parentNode) {
        if (e.hasAttribute("data-section")) return e.getAttribute("data-section");
      }

      return null;
    }

    function D() {
      if (d = !1, c = s.getVisitId(), u = s.getVisitorId(), l = b("ahoy_track"), !1 === a.cookies || !1 === a.trackVisits) x("Visit tracking disabled"), w();else if (c && u && !l) x("Active visit"), w();else if (c || (c = O(), v("ahoy_visit", c, a.visitDuration)), b("ahoy_visit")) {
        x("Visit started"), u || (u = O(), v("ahoy_visitor", u, a.visitorDuration));
        var _e3 = {
          visit_token: c,
          visitor_token: u,
          platform: a.platform,
          landing_page: window.location.href,
          screen_width: window.screen.width,
          screen_height: window.screen.height,
          js: !0
        };
        document.referrer.length > 0 && (_e3.referrer = document.referrer);

        for (var _t3 in a.visitParams) {
          a.visitParams.hasOwnProperty(_t3) && (_e3[_t3] = a.visitParams[_t3]);
        }

        x(_e3), A(a.urlPrefix + a.visitsUrl, _e3, function () {
          k("ahoy_track"), w();
        });
      } else x("Cookies disabled"), w();
    }

    s.ready = function (e) {
      d ? e() : p.push(e);
    }, s.eventProperties = function (e) {
      var t = e.target;
      return function (e) {
        for (var _t4 in e) {
          e.hasOwnProperty(_t4) && null === e[_t4] && delete e[_t4];
        }

        return e;
      }({
        tag: t.tagName.toLowerCase(),
        id: I(t.id),
        class: I(t.className),
        page: V(),
        section: N(t)
      });
    }, s.getVisitId = s.getVisitToken = function () {
      return b("ahoy_visit");
    }, s.getVisitorId = s.getVisitorToken = function () {
      return b("ahoy_visitor");
    }, s.reset = function () {
      return k("ahoy_visit"), k("ahoy_visitor"), k("ahoy_events"), k("ahoy_track"), !0;
    }, s.debug = function (e) {
      return !1 === e ? k("ahoy_debug") : v("ahoy_debug", "t", 525600), !0;
    }, s.track = function (e, t) {
      var n = {
        name: e,
        properties: t || {},
        time: new Date().getTime() / 1e3,
        id: O(),
        js: !0
      };
      return s.ready(function () {
        a.cookies && !s.getVisitId() && D(), s.ready(function () {
          x(n), n.visit_token = s.getVisitId(), n.visitor_token = s.getVisitorId(), m() ? M(n) : (g.push(n), S(), setTimeout(function () {
            C(n);
          }, 1e3));
        });
      }), !0;
    }, s.trackView = function (e) {
      var t = {
        url: window.location.href,
        title: document.title,
        page: V()
      };
      if (e) for (var _n in e) {
        e.hasOwnProperty(_n) && (t[_n] = e[_n]);
      }
      s.track("$view", t);
    }, s.trackClicks = function () {
      _("click", "a, button, input[type=submit]", function (e) {
        var t = e.target,
            n = s.eventProperties(e);
        n.text = "input" == n.tag ? t.value : (t.textContent || t.innerText || t.innerHTML).replace(/[\s\r\n]+/g, " ").trim(), n.href = t.href, s.track("$click", n);
      });
    }, s.trackSubmits = function () {
      _("submit", "form", function (e) {
        var t = s.eventProperties(e);
        s.track("$submit", t);
      });
    }, s.trackChanges = function () {
      _("change", "input, textarea, select", function (e) {
        var t = s.eventProperties(e);
        s.track("$change", t);
      });
    }, s.trackAll = function () {
      s.trackView(), s.trackClicks(), s.trackSubmits(), s.trackChanges();
    };

    try {
      g = JSON.parse(b("ahoy_events") || "[]");
    } catch (e) {}

    for (var _e4 = 0; _e4 < g.length; _e4++) {
      C(g[_e4]);
    }

    var U;
    s.start = function () {
      D(), s.start = function () {};
    }, U = function U() {
      a.startOnReady && s.start();
    }, "interactive" === document.readyState || "complete" === document.readyState ? setTimeout(U, 0) : document.addEventListener("DOMContentLoaded", U);
    var E = s;
    E.setEverfiMetadata = function (e, t) {
      var n = "ef-ahoy-" + e;
      var i = document.querySelector("meta#" + n);
      t ? (i || (i = document.createElement("meta"), i.setAttribute("id", n), i.setAttribute("name", e), document.getElementsByTagName("head")[0].appendChild(i)), i.content = t) : i && i.remove();
    }, E._track = E.track, E.track = function (e, t) {
      t && (t.text && (t.text = encodeURIComponent(t.text)), t.meta = function () {
        var e = document.getElementsByTagName("meta"),
            t = Array.from(e).reduce(function (e, t) {
          var n = t.getAttribute("id");
          return n && n.startsWith("ef-ahoy-") && (e[t.getAttribute("name")] = t.getAttribute("content")), e;
        }, {});
        if (Object.keys(t).length) return t;
      }()), E._track(e, t);
    }, E._eventProperties = E.eventProperties, E.eventProperties = function (e) {
      var t = e.target;
      return Object.assign({
        dataAttributes: t.dataset
      }, E._eventProperties(e));
    }, E.trackAll();
    t.default = E;
  }]);
});